import isUndefinedOrNull from '../../TypeHelpers/isUndefinedOrNull';
import { empty } from '../../Utilities';
export default function convert(name, value) {
    const result = [];
    if (!isUndefinedOrNull(value)) {
        if (Array.isArray(value)) {
            result.push(...convertArray(`${name}`, value));
        }
        else if (typeof value === 'object') {
            result.push(...convertObjectToQueryStringItem(value, `${name}.`));
        }
        else {
            result.push({
                name: name,
                value: value,
            });
        }
    }
    return result;
}
/**
 * Converts a `name=items[]` to a `name[index]=item` for a url query string.
 */
export function convertArray(name, arr) {
    const result = [];
    for (let i = 0; i < arr.length; i++) {
        const item = arr[i];
        result.push(...convert(`${name}[${i}]`, item));
    }
    return result;
}
export function convertObjectToQueryStringItem(obj, prefix = empty) {
    const result = [];
    for (const key in obj) {
        if (!isUndefinedOrNull(obj[key])) {
            result.push(...convert(`${prefix}${key}`, obj[key]));
        }
    }
    return result;
}
